export default __webpack_public_path__ + "static/media/Нэгдсэн уулзалт эрүүл мэндийн үйлчилгээ, цахим дата багц.3cdc7708.pdf";